__turbopack_context__.v({
  "description": "Nttueq_description",
  "headerTag": "Nttueq_headerTag",
  "image": "Nttueq_image",
  "imageWrap": "Nttueq_imageWrap",
  "title": "Nttueq_title",
});
